import Scratch from './scratch';

export default Scratch;
